import { call, debounce, put, select, takeLatest } from 'redux-saga/effects';

import { fetchUsers } from 'actions/userActions';
import { SELECT_DEALER } from 'constants/ActionTypes';
import { DEBOUNCE_TIME } from 'constants/Global';
import { PATH } from 'constants/RoutesConstants';

import { scopeToPage } from 'modules/app/sagas/utils';
import { fetchLeads } from 'modules/leads/actions/core';
import * as actionTypes from 'modules/leads/actionTypes';
import { getAssignedUserIds, getParams } from 'modules/leads/selectors/dashboard';
import { LeadsTarget } from 'modules/leads/types';

function* refreshDashboard() {
  const params: ReturnType<typeof getParams> = yield select(getParams);
  yield put(fetchLeads({ ...params, page: 0 }, { target: LeadsTarget.DASHBOARD }));
}

function* onDashboardWorker() {
  const userIds: ReturnType<typeof getAssignedUserIds> = yield select(getAssignedUserIds);
  if (userIds.length > 0) {
    yield put(fetchUsers({ ids: userIds }));
  }

  yield call(refreshDashboard);
  yield takeLatest(SELECT_DEALER, refreshDashboard);
  yield debounce(
    DEBOUNCE_TIME,
    [
      actionTypes.SET_LEADS_FILTER,
      actionTypes.SET_LEADS_FILTERS,
      actionTypes.CLEAR_LEADS_FILTERS,
      actionTypes.REMOVE_LEADS_FILTER,
    ],
    refreshDashboard
  );
}

export default function* dashboardSaga() {
  yield call(scopeToPage, [PATH.LEADS], onDashboardWorker);
}
